import { render, staticRenderFns } from "./ChildCell.vue?vue&type=template&id=cb4e7f52&scoped=true"
import script from "./ChildCell.vue?vue&type=script&lang=js"
export * from "./ChildCell.vue?vue&type=script&lang=js"
import style0 from "./ChildCell.vue?vue&type=style&index=0&id=cb4e7f52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4e7f52",
  null
  
)

export default component.exports